let EventEmitter = require('events').EventEmitter;
let emitter = new EventEmitter();
emitter.setMaxListeners(1000);

export default emitter;
